(function () {
    'use strict';

    angular
        .module('initiativeUpdateStatusAssessRoutes', [
            'businessPlanningModule'
        ])
        .config(router);

    router.$inject = ['$stateProvider'];

    function router($stateProvider) {
        $stateProvider
            .state('initiativeUpdateStatusAssess', {
                url: '/InitiativeUpdateStatus/User@{ItemPersonID:int}',
                resolve: {
                    govProcess: ['grcGovernanceProcessService', function (service) {
                        return service.getActiveInitiativeUpdateStatus();
                    }]
                },
                views: {
                    '': {
                        template: '<div ui-view="mainContent" class="initiative-update-status" autoscroll="true"></div>',
                    },
                    'mainContent@initiativeUpdateStatusAssess': {
                        controller: 'InitiativeUpdateStatusAssessController'
                    }
                }
            })

            .state('initiativeUpdateStatusAssess.noActiveProcess', {
                url: '/NoActiveProcess',
                views: {
                    'mainContent@initiativeUpdateStatusAssess': {
                        templateUrl: require('./assessNoActiveProcess.tpl.html'),
                    }
                }
            })

            .state('initiativeUpdateStatusAssess.initiatives', {
                url: '/Initiative',
                abstract: true,
                resolve: {
                    initAssessmentsByAssessor: ['$stateParams', 'initiativeUpdateStatusService', function ($stateParams, service) {
                        return service.getInitiativeAssessmentsByAssessor($stateParams.ItemPersonID);
                    }],
                },
            })

            .state('initiativeUpdateStatusAssess.initiatives.assess', {
                views: {
                    'mainContent@initiativeUpdateStatusAssess': {
                        controller: 'InitiativeUpdateStatusAssessInitiativesListController'
                    }
                },
                resolve: {
                    planLookups: ['businessPlanningService', function (service) {
                        return service.getPlanLookups();
                    }]
                }
            })

            .state('initiativeUpdateStatusAssess.initiatives.assess.welcome', {
                url: '/Welcome',
                views: {
                    'mainContent@initiativeUpdateStatusAssess': {
                        templateUrl: require('./welcome.tpl.html'),
                        controller: 'InitiativeUpdateStatusAssessInitiativesListController'
                    }
                }
            })

            .state('initiativeUpdateStatusAssess.initiatives.assess.completed', {
                url: '/Completed',
                views: {
                    'mainContent@initiativeUpdateStatusAssess': {
                        templateUrl: require('./completed.tpl.html'),
                        controller: 'InitiativeUpdateStatusAssessInitiativesListController'
                    }
                }
            })

            .state('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeAssessment', {
                url: '/{PlanInitiativeID:int}/Assess',
                views: {
                    'mainContent@initiativeUpdateStatusAssess': {
                        templateUrl: require('./byInitiativeAssessment.tpl.html'),
                        controller: 'InitiativeUpdateStatusAssessByInitiativeAssessmentController',
                        resolve: {
                            assessmentByInitiative: ['$stateParams', 'initiativeUpdateStatusService', function ($stateParams, service) {
                                return service
                                    .getAssessmentsByAssessorAndInitiative($stateParams.ItemPersonID, $stateParams.PlanInitiativeID)
                                    .then(function (assessmentsByInitiative) {
                                        if (_.isArray(assessmentsByInitiative)) return assessmentsByInitiative[0];

                                        return assessmentsByInitiative;
                                    });
                            }],
                            fiscalYearQuarterKeys: ['assessmentByInitiative', function (assessmentByInitiative) {
                                var fiscalYearQuarterKeys = _.chain(assessmentByInitiative.PlanDeliverableAssessments)
                                                        .map(function (delivAssess) {
                                                            return delivAssess.MilestoneGroup.TargetFiscalYearAndQuarter;
                                                        })
                                                        .uniq()
                                                        .value();

                                return fiscalYearQuarterKeys;
                            }]
                        }
                    }
                }
            })

            .state('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverables', {
                url: '/{PlanInitiativeID:int}/Deliverable/Assess',
                resolve: {
                    assessmentByInitiative: ['$stateParams', 'initiativeUpdateStatusService', function ($stateParams, service) {
                        return service.getAssessmentsByAssessorAndInitiative($stateParams.ItemPersonID, $stateParams.PlanInitiativeID);
                    }],
                    fiscalYearQuarterKeys: ['assessmentByInitiative', function (assessmentByInitiative) {
                        var fiscalYearQuarterKeys = _.chain(assessmentByInitiative.PlanDeliverableAssessments)
                            .map(function (delivAssess) {
                                return delivAssess.MilestoneGroup.TargetFiscalYearAndQuarter;
                            })
                            .uniq()
                            .value();

                        return fiscalYearQuarterKeys;
                    }]
                },
                views: {
                    'mainContent@initiativeUpdateStatusAssess': {
                        controller: 'InitiativeUpdateStatusAssessByInitiativeDeliverablesController',

                    }
                }
            })

            .state('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeNoDeliverables', {
                url: '/{PlanInitiativeID:int}/NoDeliverable',
                resolve: {
                    assessmentByInitiative: ['$stateParams', 'initiativeUpdateStatusService', function ($stateParams, service) {
                        return service.getAssessmentsByAssessorAndInitiative($stateParams.ItemPersonID, $stateParams.PlanInitiativeID);
                    }],
                    fiscalYearQuarterKeys: [function () {
                        return [];
                    }]
                },
                views: {
                    'mainContent@initiativeUpdateStatusAssess': {
                        controller: 'InitiativeUpdateStatusAssessByInitiativeDeliverablesController',
                        templateUrl: require('./byInitiativeNoDeliverables.tpl.html'),
                    }
                }
            })

            .state('initiativeUpdateStatusAssess.initiatives.assess.byInitiativeDeliverablesByQuarter', {
                url: '/{PlanInitiativeID:int}/Deliverable/Assess/Quarter/{FiscalYearQuarterKey}',
                params: {
                    toPrevious: { value: undefined },
                    toNext: { value: undefined }
                },
                views: {
                    'mainContent@initiativeUpdateStatusAssess': {
                        templateUrl: require('./deliverablesByQuarter.tpl.html'),
                        controller: 'InitiativeUpdateStatusAssessByQuarterDeliverablesController',
                        resolve: {
                            assessmentByInitiative: ['$stateParams', 'initiativeUpdateStatusService', function ($stateParams, service) {
                                return service.getAssessmentsByAssessorAndInitiative($stateParams.ItemPersonID, $stateParams.PlanInitiativeID);
                            }],
                            fiscalYearQuarterKeys: ['assessmentByInitiative', function (assessmentByInitiative) {
                                var fiscalYearQuarterKeys = _.chain(assessmentByInitiative.PlanDeliverableAssessments)
                                    .map(function (delivAssess) {
                                        return delivAssess.MilestoneGroup.TargetFiscalYearAndQuarter;
                                    })
                                    .uniq()
                                    .value();

                                return fiscalYearQuarterKeys;
                            }],
                            deliverableAssessmentsByQuarter: ['$stateParams', 'assessmentByInitiative', function ($stateParams, assessmentByInitiative) {
                                return _.filter(assessmentByInitiative.PlanDeliverableAssessments, {
                                    MilestoneGroup: {TargetFiscalYearAndQuarter: $stateParams.FiscalYearQuarterKey}
                                });
                            }]
                        }
                    }
                },
            });
    }
})();
